export const SubscriptionActions = {
  SET_SUBSCRIPTIONS_LIST: 'setSubscriptionsList',
  RESET_SUBSCRIPTIONS_LIST: 'resetSubscriptionsList',
  SET_SUBSCRIPTION: 'setSubscription',
  SET_SUBSCRIPTIONS: 'setSubscriptions',
  SET_CURRENT_SUBSCRIPTION_INDEX: 'setCurrentSubscriptionIndex',
  SET_SUBSCRIPTION_LOAD_FAILED: 'setSubscriptionLoadFailed',
  SET_STORE: 'setStore',
  RESET: 'reset',
};

export const setSubscriptionsList = (subscriptionsList) => ({
  type: SubscriptionActions.SET_SUBSCRIPTIONS_LIST,
  payload: subscriptionsList,
});

export const resetSubscriptionsList = () => ({
  type: SubscriptionActions.RESET_SUBSCRIPTIONS_LIST,
});

export const setSubscription = (subscription) => ({
  type: SubscriptionActions.SET_SUBSCRIPTION,
  payload: subscription,
});

export const setSubscriptions = (subscriptions) => ({
  type: SubscriptionActions.SET_SUBSCRIPTIONS,
  payload: subscriptions,
});

export const setSubscriptionLoadFailed = () => ({
  type: SubscriptionActions.SET_SUBSCRIPTION_LOAD_FAILED,
});

export const setStore = (store) => ({
  type: SubscriptionActions.SET_STORE,
  payload: store,
});

export const reset = () => ({ type: SubscriptionActions.RESET });

export const setCurrentSubscriptionIndex = (index) => ({
  type: SubscriptionActions.SET_CURRENT_SUBSCRIPTION_INDEX,
  payload: index,
});
